import { z } from 'zod';
/** Shared lane dimension schema used by both get and update features */ export const ProcessMapLaneDimensionSchema = z.object({
    laneKey: z.string().min(1),
    height: z.number().positive()
});

//# sourceMappingURL=process-map.schema.js.map